import React from 'react';
import './Loding.css';

const Loding = () => (
    <div className="loding">
        <h1 className="loding-text">Loding.......</h1>
    </div>
);

export default Loding;
